/**
 * Automated Oversight Lesson
 * Skill Area: Operations
 * Maintain visibility without micromanaging
 */

import type { LessonDefinition } from '../types';
import { AUTOMATED_OVERSIGHT_AI_PROMPT } from '../prompts/automated-oversight.prompt';

export const automatedOversight: LessonDefinition = {
  id: 'automated-oversight',
  title: 'Automate Oversight',
  displayTitle: 'Maintain Visibility Without Micromanaging',
  subTitle: 'Free yourself from micromanaging',
  persona: 'Lyra',
  skillArea: 'Operations',
  topicId: 'programs-projects',
  topicTitle: 'Programs & Projects',
  topicDescription: 'Analyze options, build plans, monitor finances, and balance team workload.',
  format: 'tool_lab',
  difficulty: 'Intermediate',
  estimatedMinutes: 7,
  tags: ['automation', 'oversight', 'dashboards'],
  dailyEligible: true,
  releasedAt: '2025-01-24T00:00:00.000Z',
  route: '/micro/automated-oversight',
  storyBeat: 'Maintain visibility across projects without constant manual checking.',
  introPrompt: "You're constantly chasing people for updates. That's not leadership—it's micromanagement. But 'just trust them' doesn't work either when you actually need visibility. Let's build a system that gives you sight without being a pest.",
  steps: [
    "Identify what you're constantly chasing people for",
    "Answer 4 questions to design your oversight system",
    "Get your Automated Visibility Dashboard + reusable prompt",
    "Practice on a second tracking need to prove mastery"
  ],
  promptGuidance: 'Choose an oversight need below or describe your own.',
  aiPrompt: AUTOMATED_OVERSIGHT_AI_PROMPT,
  inputPlaceholder: "e.g., Timesheet submissions, Grant deliverables, Team capacity...",
  quickPrompts: [
    'Timesheet submissions',
    'Project status updates',
    'Grant deliverable tracking',
    'Team capacity visibility'
  ]
};
